import { render, staticRenderFns } from "./FamilyReceiveMessageList.vue?vue&type=template&id=06f9c26b&scoped=true&lang=pug"
import script from "./FamilyReceiveMessageList.vue?vue&type=script&lang=ts"
export * from "./FamilyReceiveMessageList.vue?vue&type=script&lang=ts"
import style0 from "./FamilyReceiveMessageList.vue?vue&type=style&index=0&id=06f9c26b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9c26b",
  null
  
)

export default component.exports